import { render, staticRenderFns } from "./deactivate-user.vue?vue&type=template&id=dc7b905c"
import script from "./deactivate-user.vue?vue&type=script&lang=js"
export * from "./deactivate-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports